namespace GeniuzPOS.PriceChange {
    export interface AddPriceChangeForm {
        PostFg: Serenity.EnumEditor;
        ApproveFg: Serenity.EnumEditor;
        PluCode: Serenity.LookupEditor;
        EffectiveDate: Serenity.DateEditor;
        SellUnitPrice1Fg: Serenity.BooleanEditor;
        SellUnitPrice1: Serenity.DecimalEditor;
        SellUnitPrice2Fg: Serenity.BooleanEditor;
        SellUnitPrice2: Serenity.DecimalEditor;
        SellUnitPrice3Fg: Serenity.BooleanEditor;
        SellUnitPrice3: Serenity.DecimalEditor;
        SellUnitPrice4Fg: Serenity.BooleanEditor;
        SellUnitPrice4: Serenity.DecimalEditor;
        SellUnitPrice5Fg: Serenity.BooleanEditor;
        SellUnitPrice5: Serenity.DecimalEditor;
        SellUnitPrice6Fg: Serenity.BooleanEditor;
        SellUnitPrice6: Serenity.DecimalEditor;
    }

    export class AddPriceChangeForm extends Serenity.PrefixedContext {
        static formKey = 'PriceChange.AddPriceChange';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddPriceChangeForm.init)  {
                AddPriceChangeForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(AddPriceChangeForm, [
                    'PostFg', w0,
                    'ApproveFg', w0,
                    'PluCode', w1,
                    'EffectiveDate', w2,
                    'SellUnitPrice1Fg', w3,
                    'SellUnitPrice1', w4,
                    'SellUnitPrice2Fg', w3,
                    'SellUnitPrice2', w4,
                    'SellUnitPrice3Fg', w3,
                    'SellUnitPrice3', w4,
                    'SellUnitPrice4Fg', w3,
                    'SellUnitPrice4', w4,
                    'SellUnitPrice5Fg', w3,
                    'SellUnitPrice5', w4,
                    'SellUnitPrice6Fg', w3,
                    'SellUnitPrice6', w4
                ]);
            }
        }
    }
}
